<template>
  <v-dialog
    v-model="show"
    max-width="600"
    persistent
  >
    <v-card flat>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="close"
          icon
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="modal-content">
        <div class="table-container">
          <div class="table-header">
            <div class="header-cell header-result">
              Resultado
            </div>
            <div class="header-cell header-period">
              Período
            </div>
          </div>
          <div
            v-for="(period, index) in periods"
            :key="index"
            class="table-row"
          >
            <div class="table-cell result-cell">
              {{ formatCurrency(period.result || 0) }}
            </div>
            <div class="table-cell period-cell">
              {{ formatPeriodDate(period.startDate) }} à {{ formatPeriodDate(period.endDate) }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CompanyResultPeriodsModal',
  data: () => ({
    show: false,
    title: '',
    periods: []
  }),
  methods: {
    open({ companyName, periods }) {
      this.title = `Resultado - ${companyName || 'Empresa'}`
      this.periods = periods || []
      this.show = true
    },
    close() {
      this.show = false
      this.periods = []
      this.title = ''
    },
    formatPeriodDate(date) {
      if (!date) return '-'
      return this.$date(date)
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return '0,00'
      return this.$currencyFormat(value, 2)
    }
  }
}
</script>

<style lang="stylus" scoped>
.modal-content {
  background-color: #ffffff;
  padding: 24px;
}

.table-container {
  width: 100%;
}

.table-header {
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.header-cell {
  font-size: 14px;
  font-weight: 600;
  color: #424242;
  flex: 1;
}

.header-result {
  text-align: left;
}

.header-period {
  text-align: left;
}

.table-row {
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 12px 0;

  &:last-child {
    border-bottom: none;
  }
}

.table-cell {
  font-size: 14px;
  color: #424242;
  flex: 1;
}

.result-cell {
  text-align: left;
  font-weight: 500;
}

.period-cell {
  text-align: left;
}
</style>

